<ng-content></ng-content>

<cm-inspector-section>
    <ng-container cm-title> Point Guide </ng-container>
    <ng-container cm-content> </ng-container>
</cm-inspector-section>
